var tag = document.createElement("script");
tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName("script")[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
(function () {
  lgkorUI.showAppBottomMenuOver(true); //앱 덮는식으로 변경
  function init() {
    var template =
      "<li>" +
      '   <a href="#n" data-url="{{imagePath}}">' +
      '        <img src="{{imageServerName}}" alt="{{imageAltText}}">' +
      '        <div class="boxlist_info" data-store-Flag="{{storeFlag}}">' +
      '            <div class="info_tag">' +
      '                <span class="tag_unit">{{eventTypeNm}}</span>' +
      '                {{# if (partTypeNm.length > 0) { #}} <span class="tag_unit">{{partTypeNm}}</span> {{# } #}}' +
      "            </div>" +
      '            <div class="info_name">{{eventName}}</div>' +
      '            <div class="info_date">{{eventFromDate}} ~ {{eventToDate}}</div>' +
      "        </div>" +
      "    </a>" +
      "</li>";
    //베스트샵 지점별 홈페이지 2차 영업 안내 추천정보 20220906 start
    var template2 =
      "<li>" +
      '{{#if storeRecomType === "V"}}' +
      '<a href="#n" data-video-type="{{storeRecomType}}" data-video-url="{{videoFullPath}}" data-contents="{{contents}}">' +
      '{{#elsif storeRecomType === "Y"}}' +
      '<a href="#n" data-video-type="{{storeRecomType}}" data-video-url="{{pdpLinkUrl}}" data-contents="{{contents}}">' +
      "{{#else}}" +
      '<a href="#n" data-url="{{pdpLinkUrl}}">' +
      "{{/if}}" +
      '<img src="{{thumbImageFullPath}}" alt="{{thumbImageAltText}}">' +
      '<div class="boxlist_info">' +
      '<div class="info_type ' +
      '{{#if storeRecomType === "V"}}' +
      "video" +
      '{{#elsif storeRecomType === "Y"}}' +
      "youtube" +
      '{{#elsif storeRecomType === "B"}}' +
      "blog" +
      '{{#elsif storeRecomType === "L"}}' +
      "bestshop" +
      '{{#elsif storeRecomType === "S"}}' +
      "sns" +
      "{{/if}}" +
      '">{{storeRecomTypeNm}}</div>' +
      '<div class="info_name">{{title}}</div>' +
      '<div class="info_date">{{viewFromDate}} ~ {{viewToDate}}</div>' +
      "</div>" +
      "</a>" +
      "</li>";
    //베스트샵 지점별 홈페이지 2차 영업 안내 추천정보 20220906 end

    var coupon = {
      viewLength: 6,
      init: function (ajaxUrl, param) {
        var coupon = this;
        var infohead = $(".officehome_infohead.event");
        var data = param || {};
        infohead.each(function () {
          var $this = $(this);
          var boxlist = $this.next(".officehome_boxlist");
          var wrap = boxlist.children("ul");
          var moreArea = boxlist.find(".officehome_more");
          var moreBtn = moreArea.children(".more_btn");
          lgkorUI.requestAjaxDataFailCheck(ajaxUrl, data, function (result) {
            var list = result.eventList;
            var html = "";
            // start 20220707 LGECOMVIO-41 데이터 없을 때 null -> '' 로 변경
            if (list === null) {
              list = "";
            }
            // end 20220707 LGECOMVIO-41 데이터 없을 때 null -> '' 로 변경
            for (var i = 0; i < coupon.viewLength; i++) {
              if (list[i] !== undefined) {
                if (
                  list[i].storeFlag === null ||
                  list[i].storeFlag === undefined
                ) {
                  list[i].storeFlag = undefined;
                }
                html += vcui.template(template, list[i]);
              }
            }
            wrap.empty();
            // start 20220609 LGECOMVIO-41 데이터 없을 때 문구 노출 기능 추가
            if (list.length === 0 || list.length === undefined) {
              boxlist.find(".nolist").show();
              moreArea.hide();
              return false;
            } else {
              boxlist.find(".nolist").hide();
            }
            // end 20220609 LGECOMVIO-41 데이터 없을 때 문구 노출 기능 추가

            wrap.append(html);
            if (coupon.viewLength >= list.length) {
              moreArea.hide();
            } else {
              moreArea.show();
            }
          });

          $(document)
            .off("click")
            .on("click", ".more_btn", function () {
              coupon.more(wrap, ajaxUrl, param);
            });
        });
      },
      more: function (wrap, ajaxUrl, param) {
        var data = param || {};
        lgkorUI.requestAjaxDataFailCheck(ajaxUrl, data, function (result) {
          var list = result.eventList;
          var html = "";
          var thisLength = wrap.children("li").length;

          for (var i = thisLength; i < list.length; i++) {
            if (list[i] !== undefined && thisLength + coupon.viewLength > i) {
              if (
                list[i].storeFlag === null ||
                list[i].storeFlag === undefined
              ) {
                list[i].storeFlag = undefined;
              }
              html += vcui.template(template, list[i]);
            }
          }
          wrap.append(html);
          var moreArea = $(".officehome_more");
          if (wrap.children("li").length === list.length) {
            moreArea.hide();
          }
        });
      },
    };
    //베스트샵 지점별 홈페이지 2차 영업 안내 추천정보 20220906 start
    var recom = {
      viewLength: 6,
      page: 1,
      init: function (ajaxUrl, param) {
        var recom = this;
        var data = param || {};
        var recomList = $(document).find(".recom_list");
        var listWrap = recomList.children("ul");
        var totalCountWrap = recomList.find(".prod_count");
        var moreBtnWrap = recomList.find(".officehome_more");
        var limit = recom.viewLength;
        var pageNum = recom.page;
        var html = "";
        lgkorUI.requestAjaxDataFailCheck(ajaxUrl, data, function (result) {
          var list = result.list;
          var totalLength = result.totalCnt;
          var productmenu = $(document).find(".officehome_productmenu");
          var uiTab = productmenu.children(".ui_tab");
          if (list.length === 0) {
            //BTOCSITE-23687 [매장홈페이지] 이벤트 영역 노출 순서 변경(추천정보 탭) 20221013 START
            productmenu.find("li:eq(1)").children("a").trigger("click");
            //BTOCSITE-23687 [매장홈페이지] 이벤트 영역 노출 순서 변경(추천정보 탭) 20221013 END
            return false;
          }
          totalCountWrap.text("총 " + totalLength + "개");
          
          // 탭 변경
          uiTab.off("tabchange").on("tabchange", function (e, data) {
            window.history.replaceState(
              "",
              "",
              vcui.uri.updateQueryParam(
                location.href,
                "tabs",
                data.selectedIndex
              )
            );
            $(window).trigger("scroll");
            // 비디오 정지
            if (data.selectedIndex === 0) {
              var videoArea = $(document).find(".video_area");
              var youData = videoArea.children(".iframe_wrap").data("youVideo");
              if (youData !== undefined) {
                //유투브
                youData.pauseVideo();
              } else if (videoArea.children("video").length > 0) {
                //비디오
                videoArea.children("video")[0].pause();
              }
            }
          });
          if (lgkorUI.getParameterByName("tabs").length) {
            uiTab.vcTab("select", Number(lgkorUI.getParameterByName("tabs")));
          }

          result.list.forEach(function (el, idx) {
            // if (el.storeRecomType === "S") { //SNS
            //   // kakao navertv naverpost facebook insta
            //   el.snsType = "aaa";
            // }
            
            if(el.contents != null && el.contents != undefined && el.contents.length > 0) {
              el.contents = el.contents.replace(/(\n|\r\n)/gi, '<br>')
            }

            html += vcui.template(template2, el);
          });
          listWrap.append(html);

          //BTOCSITE-23687 [매장홈페이지] 이벤트 영역 노출 순서 변경(추천정보 탭) 20221013 START
          productmenu.addClass("appear");
          if($(".officehome_infohead.recommend").is(':visible') == false) { $(".officehome_infohead.recommend").show(); }
          if($(".officehome_boxlist.recom_list").is(':visible') == false) { $(".officehome_boxlist.recom_list").show(); }
          //BTOCSITE-23687 [매장홈페이지] 이벤트 영역 노출 순서 변경(추천정보 탭) 20221013 END

          if (totalLength <= listWrap.children("li").length) {
            moreBtnWrap.hide();
          } else {
            moreBtnWrap.show();
          }
          recom.page++;
        });
      },
    };
    //베스트샵 지점별 홈페이지 2차 영업 안내 추천정보 20220906 end

    var storeId = $(".cont-wrap.subpage .head_name").data("shopId");
    // /lg5-common/data-ajax/customer/event.json
    // /bestshop/bestshopEvent.lgajax
    coupon.init("/bestshop/bestshopEvent.lgajax", {
      shopId: storeId,
    });
    //베스트샵 지점별 홈페이지 2차 영업 안내 추천정보 20220906 start
    var recomList = $(document).find(".recom_list");
    var infoArea = $(document).find(".recom_info_cont");
    var videoArea = infoArea.find(".video_area");
    var titArea = infoArea.find(".cont_tit>strong");
    var contArea = infoArea.find(".cont_txt");
    var dateArea = infoArea.find(".period");
    infoArea.hide();
    var recomUrl =
      $(".officehome.new").data("recomUrl") ||
      "/bestshop/bestshopEventRcommend.lgajax";
    recomList.children("ul").empty();
    recomList.on("click.recom", ".more_btn", function () {
      var $this = $(this);
      recom.init(recomUrl, {
        storeId: storeId,
        page: recom.page,
      });
    });
    recomList.find(".more_btn").trigger("click.recom");
    //스크롤 시 비디오 영역 fixed
    $(window).on("scroll", function () {
      var scrollTop = $(window).scrollTop();
      var titAreaH = $(".officehome_infohead.recommend").outerHeight();
      if (
        recomList.is(":visible") &&
        (isApp() || vcui.detect.isAndroid || vcui.detect.isIOS)
      ) {
        if (scrollTop < titAreaH && videoArea.hasClass("scroll_sticky")) {
          videoArea.removeClass("scroll_sticky");
          infoArea.children(".cont_summary").css("marginTop", "");
        } else if (
          scrollTop >= titAreaH &&
          !videoArea.hasClass("scroll_sticky")
        ) {
          videoArea.addClass("scroll_sticky");
          infoArea
            .children(".cont_summary")
            .css("marginTop", videoArea.height());
        }
      }
    });
    $(window).trigger("scroll");
    //비디오 클릭 시
    $(document).on(
      "click",
      "[data-video-type=Y],[data-video-type=V]",
      function (e) {
        e.preventDefault();
        var $this = $(e.currentTarget);
        var contTxt = $this.data("contents");
        var videoType = $this.data("videoType");
        var videoUrl = $this.data("videoUrl");
        var videoHtml =
          '<video controls muted autoplay playsinline><source src="' +
          videoUrl +
          '" type="video/mp4"></video>';
        var youtubeHtml = '<div class="iframe_wrap" ><div id="youtube"></div>';

        if (videoType === "Y") {
          videoArea.html(youtubeHtml);
          var code = videoUrl.split("/");
          code = code[code.length - 1];
          var youVideo = new YT.Player("youtube", {
            width: "100%",
            height: "100%",
            videoId: code,
            playerVars: {
              // controls: 0,
              // fs: 0,
              // loop: 1,
              // modestbranding: 1,
              // playlist: code,
              // rel: 0,
              playsinline: 1,
              mute: 1,
            },
            events: {
              onReady: function (data) {
                youVideo.playVideo();
                videoArea.children(".iframe_wrap").data("youVideo", youVideo);
              },
            },
          });
        } else {
          if (videoArea.children("video").length > 0) {
            videoArea.find("source").attr("src", videoUrl);
          } else {
            videoArea.html(videoHtml);
          }
        }
        if (videoArea.hasClass("scroll_sticky")) {
          infoArea
            .children(".cont_summary")
            .css("marginTop", videoArea.height());
        }
        contArea.html(contTxt);
        titArea.text($this.find(".info_name").text());
        dateArea.text($this.find(".info_date").text());
        infoArea.show();

        $("body,html")
          .stop()
          .animate({ scrollTop: 0 }, function () {});
      }
    );
    //채널 영역 클릭 시
    $(document).on("click", ".officehome_sns .sns_list a", function (e) {
      e.preventDefault();
      var $this = $(this);
      var url = $this.attr("href");
      if (isApp()) {
        if (vcui.detect.isIOS) {
          var jsonString = JSON.stringify({
            command: "openLinkOut",
            url: url,
          });
          webkit.messageHandlers.callbackHandler.postMessage(jsonString);
        } else if (vcui.detect.isAndroid) {
          android.openLinkOut(url);
        }
      } else {
        window.open(url);
      }
    });
    //베스트샵 지점별 홈페이지 2차 영업 안내 추천정보 20220906 end
  }
  function checkStoremode() {
    var pathSplit = location.pathname.split("-");
    var strShopId = "";
    if(pathSplit.length > 1) {
      strShopId = pathSplit[1];
    }
    if(strShopId) {
      var ajaxUrl = "/bestshop/bestshopInfo.lgajax?shopId=" + strShopId;
      lgkorUI.requestAjaxDataPost(ajaxUrl, {}, function (result) {
        var data = result.shopInfo;
        if (data) {
          if (data.storeViewFlag != "Y") {
            var obj = {
              title: '.', ok: function () {
                window.location.href = "/bestshop/store-finder";
              }
            };
            var desc = '';
            obj = $.extend(obj, {title: '종료된 매장으로 매장정보를 찾을 수 없습니다.'});
            lgkorUI.alert(desc, obj);
          }
        }
      });
    }
  }

  $(document).ready(function () {
    init();
    vcui.require(["customer/bestShopModule/common"]);

    checkStoremode();
  });
})();
